import { createApp } from 'vue';
import App from './App.vue';
import router from '@/router';
import VueScrollTo from 'vue-scrollto';
import VueSweetalert2 from 'vue-sweetalert2';

createApp(App).use(VueScrollTo).use(VueSweetalert2).use(router).mount('#app');
